export default __webpack_public_path__ + "static/media/logo-example-02.799b651c.jpg";